import { render, staticRenderFns } from "./WidgetLimits.vue?vue&type=template&id=103a7a54"
import script from "./WidgetLimits.vue?vue&type=script&lang=js"
export * from "./WidgetLimits.vue?vue&type=script&lang=js"
import style0 from "./WidgetLimits.vue?vue&type=style&index=0&id=103a7a54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports